'use client';

import clsx from 'clsx';
import { parseAsInteger, useQueryState } from 'nuqs';
import { Image, ImageCarousel, getSizeByViewType } from '~/components';
import { Typography } from '@bgzt/ui';
import { useEnvironmentInfo } from '~/hooks';
import { objectToBase64 } from '@bgzt/utils';
import { goToFullWebviewOnApp } from '~/services/app-interface';

import styles from './Images.module.scss';

type Props = {
  data: string[];
  status: 'SELLING' | 'RESERVED' | 'SOLD_OUT';
};

export const Images = ({ data, status }: Props) => {
  const { isWebview } = useEnvironmentInfo();
  /** 현재 보여지는 이미지의 index */
  const [currentIndex = 0, setCurrentIndex] = useQueryState('index', parseAsInteger.withDefault(0));
  const index = currentIndex ?? 0;
  const { width, height } = getSizeByViewType('full');
  const isSelling = status === 'SELLING';

  const handleImageClick = (images: string[], imageIndex: number) => {
    if (!images || images.length < 1) return;

    const removeResolutionSuffix = (images: string[]) => images.map((image) => image.replace(/_w\d+/g, ''));
    const imagesWithoutResolution = removeResolutionSuffix(images);

    const data = objectToBase64({
      images: imagesWithoutResolution,
      index: imageIndex,
    });
    const url =
      process.env.NEXT_PUBLIC_BUNJANG_COMMON_DOMAIN + '/media-viewer' + `?data=${data}` + `&index=${imageIndex}`;

    if (isWebview) {
      goToFullWebviewOnApp({ url }).go();
      return;
    }
    globalThis.window.open(url, '_blank');
  };
  return (
    <div
      className={styles.wrapper}
      onClick={() => {
        handleImageClick(data, index);
      }}
    >
      <ImageCarousel
        data={data}
        index={index}
        onChange={setCurrentIndex}
        wrapperClassNames={clsx([!isSelling && styles.dimmed])}
      >
        {(imageSrc, index) => (
          <Image
            src={imageSrc}
            alt={`${index + 1}번째 상품 이미지`}
            fetchPriority={index === 0 ? 'high' : 'low'}
            loading={index === 0 ? 'eager' : 'lazy'}
            width={width}
            height={height}
            placeholder="background"
          />
        )}
      </ImageCarousel>

      {!isSelling && <p className={styles.status}>{status === 'RESERVED' ? '예약중' : '판매\n완료'}</p>}

      {data.length > 1 && (
        <Typography variant="L11" as="p" className={styles.indicator}>
          <strong>{index + 1}</strong> / {data.length}
        </Typography>
      )}
    </div>
  );
};
